import * as requestFromServer from './popupConfirmCustomerCrud';
import {popupConfirmCustomerSlice, callTypes} from './popupConfirmCustomerSlice';
import {RequestCancellationManager} from '../../_common/utils/RequestCancellationManager';
import {v4 as guid} from "uuid";
import moment from 'moment';
import {logUserAction} from '../../../../utils';
import {pages as P} from '../../_common/constants/pages';
import {subjects as S} from '../../_common/constants/subjects';
import {actionTypes as T} from '../../_common/constants/actionTypes';
import {logMessages as L} from '../../_common/constants/logMessages';
import {checkArrayGetSum} from '../utils/checkArrayGetSum';

const {actions} = popupConfirmCustomerSlice;

export const getPossibleCustomersListIDPrefix = 'getPossibleCustomersList';

export const getPossibleCustomersList = (
                                            idNumber = '',
                                            phone = '',
                                            email = '',
                                            filterByName = '',
                                            filterByPhone = '',
                                            filterByEmail = '',
                                            filterByIdNumber = '',
                                            filterByCustomerId = '',
                                          ) => dispatch => {
  dispatch(actions.startCall({callType: callTypes.data}));

  const requestID = `${getPossibleCustomersListIDPrefix}-${guid()}`;
  const cancellationHandlers = RequestCancellationManager.createCancellationHandlers(requestID);

  const data = {
    idNumber: parseInt(idNumber, 10),
    phone,
    email,
    filterByName,
    filterByPhone,
    filterByEmail,
    filterByIdNumber,
    filterByCustomerId
  };

  return requestFromServer
    .getPossibleCustomersList(data, cancellationHandlers)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(actions.popupConfirmCustomerDataFetched({
        entities: data
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find data';
      dispatch(actions.catchError({error, callType: callTypes.data}));
    })
    .finally(() => {
      RequestCancellationManager.forgetRequest(requestID);
    });
};

export const editOrderWithCustomerData = (data, agentID) => () => {
  return requestFromServer
    .editInvoiceOrderWithCustomerData(data)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.INVOICE_ORDERS,
        S.INVOICE_ORDER,
        T.EDIT,
        L.INVOICE_ORDERS_EDIT_WITH_CUSTOMER_DATA(
          checkArrayGetSum(data?.invoiceOrderData?.lines),
          data?.createdAt ? moment(data?.createdAt).format('DD-MM-YYYY') : '',
          agentID
        ),
        errorCode
      );

      if (errorCode !== 0) throw new Error();
    });
};
